export default {
  state: {
    showNotification: false,
    notificationMessage: {
      text: '',
      type: ''
    }
  },
  mutations: {
    setShowNotification (state, payload) {
      state.showNotification = payload
    },
    setNotificationMessage (state, payload) {
      state.notificationMessage = payload
    }
  },
  actions: {
    showNotification ({commit}, payload) {
      commit('setShowNotification', false)
      setTimeout(() => {
        commit('setShowNotification', true)
        commit('setNotificationMessage', payload)
      }, 100)
    }
  },
  getters: {
    showNotification (state) {
      return state.showNotification
    },
    notificationMessage (state) {
      return state.notificationMessage
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/notification/index.js